import { type QuizQuestionChoice } from '@efdigital/ll-addon-data';
import Component from '@glimmer/component';

import type { QuizQuestionResponseEditorComponentSignature } from '../../types/question-manager';
import CollapsibleResponse from './shared/collapsible-response.gts';

export class SingleChoiceResponseEditorComponent extends Component<QuizQuestionResponseEditorComponentSignature> {
  get questionData(): QuizQuestionChoice {
    return this.args.question.choice!;
  }

  get isScoreIndividually() {
    return this.questionData.scoring === 'individual';
  }

  <template>
    <div class="card-body p-0">
      {{#if this.isScoreIndividually}}
        <div class="form-label p-3">Configure the feedback shown when each
          option is chosen:</div>

        {{#each this.questionData.choices as |option|}}
          <CollapsibleResponse
            @label={{option.value}}
            @response={{option.response}}
          />
        {{/each}}
      {{else}}
        <div class="form-label p-3">Configure feedback for correct and incorrect
          answers:</div>

        <CollapsibleResponse
          @label="Feedback if correct"
          @response={{this.questionData.response}}
        />

        <CollapsibleResponse
          @label="Feedback if incorrect"
          @response={{this.questionData.response0}}
        />
      {{/if}}
    </div>
  </template>
}
